import { Colors } from '@back-office/core';
import { Variant } from '@material-ui/core/styles/createTypography';
import { Property } from 'csstype';
import React, { FC } from 'react';
import NumberFormat from 'react-number-format';
import GcpBox from '../gcp-box';
import GcpTypography from '../gcp-typography';

interface GcpTextNumberFormatProps {
  prefix?: string;
  suffix?: string;
  value: string | number | null;
  paint?: keyof Colors;
  align?: Property.JustifyContent;
  valueVariant?: Variant;
  valueWeight?: Property.FontWeight;
  suffixVariant?: Variant;
  fixedDecimalScale?: boolean;
}

const GcpCurrencyFormat: FC<GcpTextNumberFormatProps> = (props) => {
  const {
    prefix,
    paint,
    suffix,
    value,
    suffixVariant,
    valueVariant,
    align,
    valueWeight,
    fixedDecimalScale,
  } = props;

  return (
    <GcpBox display="flex" gap={1} justifyContent={align}>
      <GcpTypography
        paint={paint || 'black'}
        variant={valueVariant || 'body1'}
        weight={valueWeight}
      >
        <NumberFormat
          isNumericString
          decimalScale={2}
          decimalSeparator="."
          defaultValue={0}
          displayType="text"
          fixedDecimalScale={fixedDecimalScale}
          prefix={prefix}
          thousandSeparator=","
          value={value || '0'}
        />
      </GcpTypography>
      {suffix && (
        <GcpTypography variant={suffixVariant || valueVariant || 'body1'}>
          {suffix}
        </GcpTypography>
      )}
    </GcpBox>
  );
};

export default GcpCurrencyFormat;
